import React from "react";
import { useBooking } from "@/lib/booking-context";
import { CONTACT } from "@/data/content";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Footer = () => {
  const { openBooking } = useBooking();
  return (
    <footer className="bg-warmwhite border-t border-stone/70 pt-20 pb-10" data-testid="footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-5">
            <h3 className="font-serif text-3xl text-charcoal">The <span className="italic">Standard</span></h3>
            <p className="mt-5 text-charcoal/60 leading-relaxed max-w-sm text-[15px]">
              The standard for luxury home care — designed around your home. Concierge-level care for discerning homeowners.
            </p>
            <button
              onClick={openBooking}
              className="mt-8 px-7 py-3 bg-charcoal text-warmwhite rounded-full text-sm font-semibold transition-all duration-300 hover:bg-champagne hover:scale-[1.03]"
              data-testid="footer-schedule-btn"
            >
              Schedule Your Cleaning
            </button>
          </div>

          <div className="md:col-span-3 md:col-start-7">
            <p className="overline text-charcoal/40 mb-6">Explore</p>
            <ul className="space-y-4 text-charcoal/70 text-[15px]">
              <li><button onClick={() => scrollTo("experiences")} className="link-underline" data-testid="footer-experiences">Experiences</button></li>
              <li><button onClick={() => scrollTo("standard")} className="link-underline" data-testid="footer-standard">The Standard</button></li>
              <li><button onClick={() => scrollTo("how-it-works")} className="link-underline" data-testid="footer-how">How It Works</button></li>
              <li><button onClick={() => scrollTo("reviews")} className="link-underline" data-testid="footer-reviews">Reviews</button></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-charcoal/40 mb-6">Contact</p>
            <ul className="space-y-4 text-charcoal/70 text-[15px]">
              <li><a href={CONTACT.phoneHref} className="link-underline" data-testid="footer-phone">{CONTACT.phone}</a></li>
              <li><a href={`mailto:${CONTACT.email}`} className="link-underline" data-testid="footer-email">{CONTACT.email}</a></li>
              <li className="text-charcoal/50">{CONTACT.serviceArea}</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-stone/60 flex flex-col md:flex-row justify-between items-center gap-4 text-charcoal/40 text-xs">
          <p>© {new Date().getFullYear()} The Standard. All rights reserved.</p>
          <p className="tracking-wide">Peace of mind, restored.</p>
        </div>
      </div>
    </footer>
  );
};
